export default __webpack_public_path__ + "static/media/successfulPayment.a05ce97d.gif";